// @flow
import AddZmCollectionAssets from '../queries/lightbox/assets/AddZmCollectionAssets';
import { SimpleResponse, FuidRrnInfo } from '../autogenerated/ZoomBridge';

const debug = require('../debug/debug')('wc:upload:runAddZmCollectionAssetsQuery');

export default async function runAddZmCollectionAssetsQuery(
  fuidRrnList: FuidRrnInfo[],
  collectionId: number
): SimpleResponse {
  try {
    debug('Begin');
    const query = new AddZmCollectionAssets(collectionId, fuidRrnList);
    const res = await query.run();
    debug('Success');
    return res;
  } catch (err) {
    debug('Error: ', err);
    window.setError(err.toString());
  }
}
